import { kernelsClient } from "@kaggle/sdk";
import {
  getCurrentDataSources,
  getCurrentKernelRunId,
} from "../../selectors/current";
import { getStore } from "../../store/appStore";
import { DataSourceExtended } from "../../types/DataSourceExtended";
import { setDataSources } from "../notebook";
import { appendTerminalError } from "../terminal";
import { mapSourcesToSourceReferences } from "../worker";

export const checkWorkspaceUpdates = async () => {
  const state = getStore().getState();

  try {
    if (!state.notebook.kernel || getCurrentDataSources(state).length === 0) {
      return;
    }

    const kernelRunId = getCurrentKernelRunId(state) || 0;
    if (kernelRunId === 0) {
      return;
    }
    const sourceReferences = mapSourcesToSourceReferences(
      state.notebook.dataSources
    );
    const dryRunResponse = await kernelsClient.updateKernelRunDataSources({
      sessionId: kernelRunId,
      dataSources: sourceReferences,
      dryRun: true,
    });
    if (!dryRunResponse.anyChanges) {
      return;
    }
    const dataSources = getCurrentDataSources(state);
    const referenceWithNewVersions = dryRunResponse.results
      .filter(r => r.newVersion)
      .map(r => r.reference);
    const updatedDataSource: DataSourceExtended[] = dataSources.map(ds => {
      return {
        ...ds,
        refreshAvailable: referenceWithNewVersions.some(
          r => r.mountSlug === ds.mountSlug
        ),
      };
    });
    setDataSources(updatedDataSource);
  } catch (error) {
    appendTerminalError(
      "An error occurred checking for data source updates.",
      error
    );
  }
};
